// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__yfipN","title":"FrontImage_title__3QhhF"};